import Link from "next/link";

import { routes } from "src/shared/routes";
import { openPdfInNewTab } from "src/utils/utils";
import { global_config } from "src/shared/global_config";
import { useSSTheme } from "src/components/reusable/hooks/useSSTheme";
import { useCssMediaQuery } from "src/components/base/hooks/useCssMediaQuery";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

<Link
  href={{
    pathname: routes.manage_subscription,
    query: { teamSchema: "stlouisblues_pass" },
  }}
>
  Manage Subscription
</Link>;

export const FAQS: TTeamConfig["LANGUAGES"]["FAQS"] = [
  {
    question:
      "How do I claim my tickets? When does the opt in open before each game?",
    answer:
      "You will receive a text when the window to check-in is open. The check-in window starts at 9 am on the first game day of a homestand. You will have an opportunity to check-in for all the games in the series and purchase guest tickets & upgrades as well (if available).",
  },
  {
    question:
      "Do I get a ticket to each game on the schedule? Are there penalties if I do not check-in?",
    answer:
      "Tickets are guaranteed for each game on the schedule. There are no penalties for not attending a game, however you do need to confirm your attendance in order to receive a ticket.",
  },
  {
    question: "Where are my tickets?",
    answer: (
      <>
        Your tickets will be sent over 3 hours prior to game start and you can
        find the tickets within your Reno Aces{" "}
        <Link
          href={
            "https://mlb.tickets.com/?agency=RENM_MYTIXX&orgid=53073&_ga=2.216326614.1142316861.1674493887-1300012152.1641491490#/auth/login"
          }
        >
          MyTickets account.
        </Link>
      </>
    ),
  },
  {
    question: "How are tickets sent to me?",
    answer: (
      <>
        3 hours prior to game start you will receive a text confirming that
        tickets have been delivered to your Reno Aces{" "}
        <Link
          href={
            "https://mlb.tickets.com/?agency=RENM_MYTIXX&orgid=53073&_ga=2.216326614.1142316861.1674493887-1300012152.1641491490#/auth/login"
          }
        >
          MyTickets account.
        </Link>
      </>
    ),
  },
  {
    question: "Where will my seats be located?",
    answer: "Seat locations will vary by game.",
  },
  {
    question: "Can these tickets be transferred to a friend?",
    answer:
      "Ballpark Pass tickets, as well as seat upgrades and guest passes, are not eligible for resale. Abusing these guidelines can result in your Ballpark Pass being revoked.",
  },
  {
    question: "Can my seats be changed?",
    answer:
      "Once tickets have been sent to your account, they cannot be changed. Please contact info@renoaces.com for any assistance you may require.",
  },
  {
    question: "Can I bring a friend to a game?",
    answer:
      "Guest tickets & upgrades will be available for select games. If available, guest tickets are available for purchase when you opt into games.",
  },
  {
    question: "Can I receive a refund if I cannot attend a game?",
    answer: "We do not issue any refunds for games you are not able to attend.",
  },
  {
    question: "How can I get a refund and cancel my pass?",
    answer:
      "Please contact info@renoaces.com for any requests for refunds or cancellations.",
  },
];
